/**
 * GW Swatch -> Size-Pill Sync
 *
 * Ersetzt den frueheren jQuery-Block, der in vier Collection-Sections dupliziert war
 * und jQuery von cdn-script.com nachgeladen hat (Host tot -> render-blocking Timeout).
 * Reines Vanilla JS, keine externe Abhaengigkeit.
 *
 * Klick auf einen Farb-Swatch innerhalb einer Produktkachel aktualisiert die
 * Groessen-Pills: ausverkaufte Groessen werden markiert, Links auf die passende
 * Variante der geklickten Farbe umgeschrieben.
 */
(function () {
  'use strict';

  // Das Asset wird von mehreren Sections eingebunden; nur einmal initialisieren.
  if (window.__gwSwatchPillsInit) return;
  window.__gwSwatchPillsInit = true;

  var SWATCH_SELECTOR = 'tooltip-component[data-swatch-button], .swatch__label[data-swatch]';

  function getOptionValue(variant, index) {
    if (index === 0) return variant.option1;
    if (index === 1) return variant.option2;
    return variant.option3;
  }

  function parseJSONFrom(productBlock, attr, pid) {
    var node = productBlock.querySelector('[' + attr + '="' + pid + '"]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function updateSizePills(productBlock, clickedColor) {
    var pillsContainer = productBlock.querySelector('[data-size-pills]');
    if (!pillsContainer) return;

    var pid = pillsContainer.getAttribute('data-product-id');
    var variants = parseJSONFrom(productBlock, 'data-variants-json', pid);
    var options = parseJSONFrom(productBlock, 'data-options-json', pid);
    if (!variants || !options) return;

    var colorIdx = options.color_index;
    var sizeIdx = options.size_index;

    pillsContainer.querySelectorAll('.size-pill').forEach(function (pill) {
      var size = pill.getAttribute('data-size-value');
      var match = null;

      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (getOptionValue(v, colorIdx) === clickedColor && getOptionValue(v, sizeIdx) === size) {
          if (!match) match = v;
          if (v.available) {
            match = v;
            break;
          }
        }
      }

      if (!match) return;

      if (match.available) {
        pill.classList.remove('is-sold-out');
        pill.removeAttribute('aria-disabled');
      } else {
        pill.classList.add('is-sold-out');
        pill.setAttribute('aria-disabled', 'true');
      }

      var href = pill.getAttribute('href');
      if (href) pill.setAttribute('href', href.split('?')[0] + '?variant=' + match.id);
    });
  }

  // Delegation: faengt Klicks auf .swatch__label selbst ODER auf Kinder
  // innerhalb von tooltip-component[data-swatch-button].
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var clicked = target.closest(SWATCH_SELECTOR);
    if (!clicked) return;

    var swatchLabel = clicked.classList.contains('swatch__label')
      ? clicked
      : clicked.querySelector('.swatch__label[data-swatch]');
    if (!swatchLabel) return;

    var color = swatchLabel.getAttribute('data-swatch');
    if (!color) return;

    var productBlock = clicked.closest('[data-product-block]');
    if (!productBlock || !productBlock.querySelector('[data-size-pills]')) return;

    updateSizePills(productBlock, color);
  });
})();
